export default "__VITE_ASSET__BE3sQMFl__"